/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Navigate_Open_AgentInputs */



/**
* | output |
* | --- |
* | "Open the agent" |
*
* @param {Uno_Navigate_Open_AgentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_navigate_open_agent = /** @type {((inputs?: Uno_Navigate_Open_AgentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Navigate_Open_AgentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agent öffnen")
	return /** @type {LocalizedString} */ ("Open the agent")
});